import { render, staticRenderFns } from "./TenderInfoTab.vue?vue&type=template&id=d2023682&scoped=true"
import script from "./TenderInfoTab.vue?vue&type=script&lang=js"
export * from "./TenderInfoTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2023682",
  null
  
)

export default component.exports